import React, { useEffect, useState } from "react";

import clientFive from "../../assets/c5.png";
import clientNine from "../../assets/c9.png";
import clientTen from "../../assets/c10.png";
import vendornix from "../../assets/vendornix_ev.png";
import { useLanguage } from "../../i18n/LanguageProvider";
import RevealOnScroll from "../RevealOnScroll";

const fallbackPartners = [
  {
    id: "fallback-1",
    name: "E’Many Plazzo Services",
    altText: "E’Many Plazzo Services",
    logoUrl: clientFive,
  },
  {
    id: "fallback-2",
    name: "Cabinet de Naturopathie Warrior",
    altText: "Cabinet de Naturopathie Warrior",
    logoUrl: clientNine,
  },
  {
    id: "fallback-3",
    name: "Client WonyaSoft",
    altText: "Client WonyaSoft",
    logoUrl: clientTen,
  },
  {
    id: "fallback-4",
    name: "Vendornix Events",
    altText: "Vendornix Events",
    logoUrl: vendornix,
  },
];

const apiBase = () => {
  if (process.env.REACT_APP_PUBLIC_API_URL) {
    return process.env.REACT_APP_PUBLIC_API_URL.replace(/\/+$/, "");
  }
  return ["localhost", "127.0.0.1"].includes(window.location.hostname)
    ? "http://127.0.0.1:8080"
    : "https://app.wonyaso.com";
};

const TrustedPartners = () => {
  const { language, t } = useLanguage();
  const [content, setContent] = useState({
    titleFr: "Ils nous font confiance",
    titleEn: "They trust us",
    partners: fallbackPartners,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      if (
        process.env.NODE_ENV === "test" ||
        typeof window.fetch !== "function"
      ) {
        setLoading(false);
        return;
      }
      try {
        const response = await window.fetch(`${apiBase()}/public/site-trust`, {
          signal: controller.signal,
          headers: { Accept: "application/json" },
        });
        if (!response.ok) throw new Error("Public content unavailable");
        const payload = await response.json();
        if (payload?.success && payload.data) {
          setContent(payload.data);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          setContent((current) => ({ ...current, partners: fallbackPartners }));
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    load();
    return () => controller.abort();
  }, []);

  if (!loading && content.partners.length === 0) return null;

  return (
    <section className="ws-partners" aria-labelledby="ws-partners-title">
      <div className="ws-shell">
        <RevealOnScroll as="h2" id="ws-partners-title">
          {language === "en" ? content.titleEn : content.titleFr}
        </RevealOnScroll>
        <RevealOnScroll
          className="ws-partners__grid"
          variant="fade-left"
          role="group"
          aria-label={t("Organisations qui nous font confiance")}
        >
          {loading
            ? Array.from({ length: 4 }, (_, index) => (
                <span
                  className="ws-partners__skeleton"
                  aria-hidden="true"
                  key={index}
                />
              ))
            : content.partners.map((partner) => (
                <img
                  src={partner.logoUrl}
                  alt={partner.altText || partner.name}
                  loading="lazy"
                  width="180"
                  height="64"
                  key={partner.id}
                />
              ))}
        </RevealOnScroll>
      </div>
    </section>
  );
};

export default TrustedPartners;
